import React, { useEffect, useState } from 'react';

function useTheme() {
  /*
  const defaultTheme = localStorage.theme ? localStorage.theme : 'dark';
  const [theme, setTheme] = useState(defaultTheme)
  const oppositeTheme = 'dark' === theme ? 'light' : 'dark';


  const toggleTheme = () => {
    setTheme(oppositeTheme)
  }

  useEffect(() => {
    const root = window.document.documentElement;
    root.classList.remove(oppositeTheme);
    root.classList.add(theme);
    localStorage.setItem('theme', theme);
  }, [theme]);

  return [theme, toggleTheme]

   */
}

export default useTheme;
